import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { OrderListUpdate } from "../../../API/routine";
import { toast } from "react-toastify";
import {
  TableDeleteBtn,
  TableEditBtn,
  TableViewBtn,
} from "../../../images/Svgs";
import { CustomToolTip, formatAMPM } from "../../../utils/common";

const EventDetailList = ({
  handleEditRoutine,
  routingList,
  handleDeleteRoutine,
  handleDetailRoutine,
  handleLogisticsChange,
  eventId,
  fetchRoutine,
}) => {
  const [rows, setRows] = useState([]);
  const [activeRowId, setActiveRowId] = useState(null);
  const IsAccess = JSON.parse(localStorage.getItem("userDetail"));
  useEffect(() => {
    setRows(routingList);
  }, [routingList]);

  const onDragEnd = async (result) => {
    if (!result.destination) return;
    const reordered = [...rows];
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);

    const updatedArray = reordered.map((row, i) => ({
      id: row.id,
      index: i,
    }));

    const previousID = rows[result.source.index]?.id;
    const newID = rows[result.destination.index]?.id;

    setRows(reordered);
    await onChange(updatedArray, previousID, newID);
  };

  const onChange = async (data, previousID, newID) => {
    const payload = {
      event_id: eventId,
      previous_id: previousID,
      new_id: newID,
      order_list_update: data,
    };

    try {
      const response = await OrderListUpdate(payload);
      if (response?.status) {
        fetchRoutine();
        toast.success(response.message || "Success!");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during API request:", error);
    }
  };

  const handleAccessChange = async (userId, changes) => {
    // const payload = {
    //   id: userId,
    //   completed:
    //     changes?.props !== undefined
    //       ? 0
    //       : changes?.completed !== ""
    //       ? changes?.completed === true
    //         ? 1
    //         : 0
    //       : "",
    //   starts:
    //     changes?.starts !== undefined
    //       ? changes?.starts
    //       : changes?.props !== undefined
    //       ? 0
    //       : "",
    // };
    const payload = {
      id: userId,
      completed:
        changes?.props !== undefined
          ? 0
          : changes?.completed !== ""
          ? changes?.completed === true
            ? 1
            : 0
          : 0,
    };

    // Only include 'starts' if it has a valid value
    if (typeof changes?.starts !== "undefined") {
      payload.starts = changes.starts;
    }

    if (changes?.props !== undefined) payload.props = changes.props;
    if (changes?.previousId) payload.previous_id = changes.previousId;

    await handleLogisticsChange(payload);

    if (changes.starts === 1) {
      setActiveRowId(userId);
    } else if (changes.starts === 2 || changes.completed === true) {
      setActiveRowId(null);
    }
  };

  return (
    <div
      className="container-fluid"
      style={{ height: "350px", overflowY: "auto" }}
    >
      <table className="table">
        <thead className="text-center">
          <tr>
            <th>Time</th>
            <th>Entry</th>
            <th>Entry Title</th>
            <th>Age</th>
            <th>Level</th>
            <th>Entry Division</th>
            <th>Performers</th>
            <th>Category</th>
            <th>Starts</th>
            <th>Props</th>
            <th>Actions</th>
            <th>Completed</th>
          </tr>
        </thead>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="routineTable">
            {(provided, snapshot) => (
              <tbody ref={provided.innerRef} {...provided.droppableProps}>
                {rows.map((row, index) => (
                  <Draggable
                    key={row.id}
                    draggableId={row.id.toString()}
                    index={index}
                  >
                    {(provided) => (
                      <tr
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className={`text-center ${
                          row.starts === 1 ||
                          row.starts === 2 ||
                          row.completed === 1
                            ? "start"
                            : "notstart"
                        }`}
                        style={{
                          cursor: row.completed === 1 ? "not-allowed" : " ",
                          ...provided.draggableProps.style,
                          // position: snapshot.isDragging ? "absolute" : "static", // Fix position during drag
                          zIndex: snapshot.isDragging ? 999 : "auto", // Ensure it is above other rows
                          width: "100%", // Keep width of table consistent
                          left: snapshot.isDragging ? "0" : "auto", // Prevent misalignment
                          transition: "all 0.1s ease-out", // Smooth transition
                        }}
                      >
                        <td>{formatAMPM(row?.event_time_from)}</td>
                        <td>{row?.entry || "-"}</td>
                        <td>{row?.entry_title || "-"}</td>
                        <td>{row?.masterAgeClass?.name || "-"}</td>
                        <td>{row?.masterLevel?.name || "-"}</td>
                        <td>{row?.masterEntryDivision?.name || "-"}</td>
                        <td>{row?.performers || "-"}</td>
                        <td>{row?.masterMusicCategory?.name || "-"}</td>
                        {/* <td>
                          {row?.type === "routine" && IsAccess?.is_access ? (
                            <div className="checkbox-wrapper">
                              <label
                                htmlFor={`on-${row.id}`}
                                className="checkbox-label check_box_btn"
                              >
                                <input
                                  type="checkbox"
                                  id={`on-${row.id}`}
                                  checked={row.starts === 1 || row.starts === 2}
                                  disabled={row.completed === 1}
                                  onChange={async () => {
                                    if (row.starts === 1) {
                                      await handleAccessChange(row.id, {
                                        starts: 0,
                                        completed: false,
                                      });
                                      setActiveRowId(null);
                                      return;
                                    }
                                    const previousId = activeRowId;
                                    await handleAccessChange(row.id, {
                                      starts: 1,
                                      completed: false,
                                      previousId,
                                    });
                                    setActiveRowId(row.id);
                                  }}
                                />
                                <p>On</p>
                              </label>
                              <label
                                htmlFor={`off-${row.id}`}
                                className="checkbox-label check_box_btn"
                              >
                                <input
                                  type="checkbox"
                                  id={`off-${row.id}`}
                                  checked={row.starts === 2}
                                  disabled={
                                    row.completed === 1
                                    // (activeRowId !== null &&
                                    //   activeRowId !== row.id &&
                                    //   !row.completed)
                                  }
                                  onChange={() => {
                                    if (row.starts === 1) {
                                      handleAccessChange(row.id, {
                                        starts: 2,
                                        completed: false,
                                      });
                                    } else if (row.starts === 2) {
                                      handleAccessChange(row.id, {
                                        starts: 0,
                                        completed: false,
                                      });
                                      setActiveRowId(row.id);
                                    }
                                  }}
                                />
                                <p>Off</p>
                              </label>
                            </div>
                          ) : (
                            "-"
                          )}
                        </td> */}
                        <td>
                          {row?.type === "routine" && IsAccess?.is_access ? (
                            <div className="checkbox-wrapper">
                              {/* ON Checkbox */}
                              <label
                                htmlFor={`on-${row.id}`}
                                className="checkbox-label check_box_btn"
                              >
                                <input
                                  type="checkbox"
                                  id={`on-${row.id}`}
                                  checked={row.starts === 1}
                                  disabled={row.completed === 1}
                                  onChange={async () => {
                                    if (row.starts === 1) {
                                      await handleAccessChange(row.id, {
                                        starts: 0,
                                        completed: false,
                                      });
                                      setActiveRowId(null);
                                    } else {
                                      await handleAccessChange(row.id, {
                                        starts: 1,
                                        completed: false,
                                        previousId: activeRowId,
                                      });
                                      setActiveRowId(row.id);
                                    }
                                  }}
                                />
                                <p>On</p>
                              </label>

                              {/* OFF Checkbox */}
                              <label
                                htmlFor={`off-${row.id}`}
                                className="checkbox-label check_box_btn"
                              >
                                <input
                                  type="checkbox"
                                  id={`off-${row.id}`}
                                  checked={row.starts === 2}
                                  disabled={row.completed === 1}
                                  onChange={async () => {
                                    if (row.starts === 2) {
                                      await handleAccessChange(row.id, {
                                        starts: 0,
                                        completed: false,
                                      });
                                      setActiveRowId(null);
                                    } else {
                                      await handleAccessChange(row.id, {
                                        starts: 2,
                                        completed: false,
                                      });
                                      setActiveRowId(null);
                                    }
                                  }}
                                />
                                <p>Off</p>
                              </label>
                            </div>
                          ) : (
                            "-"
                          )}
                        </td>

                        <td>
                          {row?.type === "routine" ? (
                            <label className="container">
                              <input
                                type="checkbox"
                                checked={row?.props === 1}
                                disabled={row?.completed === 1}
                                onChange={(e) => {
                                  handleAccessChange(row.id, {
                                    props: e.target.checked ? 1 : 0,
                                    starts: row.starts ? row.starts : 0,
                                    completed: "",
                                  });
                                }}
                              />
                              <span className="checkmark"></span>
                            </label>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>
                          <button
                            className="btn position-relative"
                            onClick={() => handleEditRoutine(row.id)}
                          >
                            <TableEditBtn />
                            <CustomToolTip type="edit" title="Routine" />
                          </button>
                          <button
                            className="btn position-relative"
                            onClick={() => handleDetailRoutine(row.id)}
                          >
                            <TableViewBtn />
                            <CustomToolTip type="view" title="Routine" />
                          </button>
                          <button
                            className="btn position-relative"
                            onClick={() => handleDeleteRoutine(row.id)}
                          >
                            <TableDeleteBtn />
                            <CustomToolTip type="delete" title="Routine" />
                          </button>
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            checked={row.completed === 1}
                            onChange={(e) => {
                              if (row.completed === 0) {
                                handleAccessChange(row.id, {
                                  completed: e.target.checked,
                                  starts: row.starts ? row.starts : 0,
                                });
                              }
                            }}
                          />
                        </td>
                      </tr>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </tbody>
            )}
          </Droppable>
        </DragDropContext>
      </table>
    </div>
  );
};

export default EventDetailList;
